import { RichTextEditor } from "../../ui/RichTextEditor";
import { type MessageDraftKey, messageDraftStore } from "./messageDraftStore";
import { useMessageDraft } from "./useMessageDraft";

export type MessageComposerProps = {
	draftKey: MessageDraftKey;
	createComment: (message: string) => Promise<unknown>;
	sending: boolean;
	placeholder?: string;
};

export const MessageComposer = ({
	draftKey,
	createComment,
	sending,
	placeholder,
}: MessageComposerProps) => {
	const [draft, setDraft] = useMessageDraft(draftKey);

	const send = async (message: string) => {
		await createComment(message);
		// The editor may have unmounted by now, so clear here, and only if the draft is unchanged.
		if (messageDraftStore.get(draftKey) === message) messageDraftStore.set(draftKey, "");
	};

	return (
		<RichTextEditor
			// Remount per entity so no send state carries over from the previous one.
			key={draftKey}
			content={draft}
			onUpdate={setDraft}
			preserveWhitespace
			onConfirmClick={send}
			confirmPending={sending}
			isComment
			placeholder={placeholder}
		/>
	);
};
